import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.subgroups,"loading":_vm.loading,"loading-text":"Loading... Please wait","hide-default-footer":""},on:{"click:row":_vm.editItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }